import { memo, useState } from 'react';
import { roundBook, fmtBook } from '../../utils/casinoBook';

function isSusp(item) {
  return !item || item.gstatus === 'SUSPENDED' || item.gstatus === '0';
}

function suspCls(item) {
  return isSusp(item) ? ' suspended' : '';
}

function fmtAmt(n) {
  const x = Number(n) || 0;
  if (x >= 100000) return `${x / 100000}L`;
  if (x >= 1000) return `${x / 1000}K`;
  return String(x);
}

function bookOf(exposures, name, sid) {
  return roundBook(exposures?.[`sid:${sid}`] ?? exposures?.[name] ?? 0);
}

function bookCls(v) {
  return v < 0 ? 'book-red' : v > 0 ? 'book-green' : 'book-black';
}

const LEFT = ['Player 8', 'Player 9'];
const RIGHT = ['Player 10', 'Player 11'];
const RANGE_ID = { 'Player 8': 'demo0', 'Player 9': 'demo1', 'Player 10': 'demo2', 'Player 11': 'demo3' };

const PlayerRow = memo(function PlayerRow({ name, item, rangeId, onBet, exposures }) {
  const [open, setOpen] = useState(false);
  const book = bookOf(exposures, item?.nat ?? name, item?.sid);
  return (
    <div className="casino-box-row">
      <div className="casino-nation-name">
        <b>{name}</b>
        {' '}
        <div className="float-right">
          <span className={`mr-2 casino-book ${bookCls(book)}`}>{fmtBook(book)}</span>
          {' '}
          <i
            data-toggle="collapse"
            data-target={`#${rangeId}`}
            className="fas fa-info-circle"
            onClick={() => setOpen((o) => !o)}
          ></i>
          {' '}
          <div id={rangeId} className={`collapse icon-range${open ? ' show' : ''}`}>
            Range:
            <span>{fmtAmt(item?.min ?? 100)}</span>
            -
            <span>{fmtAmt(item?.max ?? 300000)}</span>
          </div>
        </div>
      </div>
      <div className={`casino-bl-box${suspCls(item)}`}>
        <div
          data-toggle="modal"
          data-target="#casino-betslip"
          className="back casino-bl-box-item"
          onClick={isSusp(item) ? undefined : () => onBet(item.sid, 'back', item.b, item)}
        >
          <span className="casino-box-odd">{item?.b ?? 0}</span>
        </div>
        <div
          className="lay casino-bl-box-item"
          onClick={isSusp(item) ? undefined : () => onBet(item.sid, 'lay', item.l, item)}
        >
          <span className="casino-box-odd">{item?.l ?? 0}</span>
        </div>
      </div>
    </div>
  );
});

const BetTableCard32 = memo(function BetTableCard32({ gameData, onBet, exposures }) {
  const sub = gameData?.sub || [];
  const handleBet = onBet || (() => {});
  const find = (name) => sub.find((s) => s.nat === name);

  return (
    <div className="teen1daycasino-container">
      <div className="teen1dayleft">
        {LEFT.map((name) => (
          <PlayerRow key={name} name={name} item={find(name)} rangeId={RANGE_ID[name]} onBet={handleBet} exposures={exposures} />
        ))}
      </div>
      <div className="teen1daycenter"></div>
      <div className="teen1dayright">
        {RIGHT.map((name) => (
          <PlayerRow key={name} name={name} item={find(name)} rangeId={RANGE_ID[name]} onBet={handleBet} exposures={exposures} />
        ))}
      </div>
    </div>
  );
});

export default BetTableCard32;
